import React from "react";

const Header = () => {
  return (
    <div>
      <div className="header">
        <a href="#default" className="logo">
          HESN
        </a>
        <div className="header-right">
          <p to="/">Assessments</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
